import * as React from 'react';
import { MenuItem, Paper, MenuList, Popper } from '@mui/material';

import { colors, fontFamily } from 'styles/globalStyles';

interface Props {
  text: string;
  active: boolean;
  children?: React.ReactNode;
}

const NavBarNestedItem = ({ text, active, children }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  return (
    <div onMouseLeave={handleMouseLeave}>
      <MenuItem
        onMouseEnter={handleMouseEnter}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontFamily,
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '19px',
          letterSpacing: '-0.32px',
          textTransform: 'capitalize',
          padding: '6px 16px',
          minHeight: 'unset',
          backgroundColor: active ? colors.red : 'transparent',
          color: active ? colors.white : '#212529',
          '&:hover': {
            backgroundColor: active ? colors.red : colors.aliceBlue,
          },
        }}
      >
        {text}
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          style={{ marginLeft: '8px', flexShrink: 0 }}
        >
          <path
            d="M1.5 1L6.5 6L1.5 11"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </MenuItem>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="right-start"
        style={{ zIndex: 1300 }}
      >
        <Paper
          sx={{
            border: '1px solid #e1e1e1',
            borderRadius: '4px',
            boxShadow: 'none',
          }}
          onMouseLeave={handleMouseLeave}
        >
          <MenuList disablePadding>
            {children}
          </MenuList>
        </Paper>
      </Popper>
    </div>
  );
};

export default NavBarNestedItem;
